import type { ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { PlainTooltip } from "@similarweb/ui-components";

import { StyledHeaderCellText } from "app/components/React/Table/headerCells/HeaderCellBold/styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import {
    HeaderCellBoldWithInfoWrapper,
    StyledHeaderCellBoldWrapper,
    StyledIconInfoWrapper,
} from "app/pages/workspace/StyledComponent";

type HeaderCellBoldWithInfoIconProps = {
    displayName: ReactNode;
    tooltipText?: string;
};

const HeaderCellBoldWithInfoIcon = (props: HeaderCellBoldWithInfoIconProps) => {
    return (
        <HeaderCellBoldWithInfoWrapper>
            <>
                <StyledHeaderCellBoldWrapper>
                    <StyledHeaderCellText data-automation="header-cell.text">{props.displayName}</StyledHeaderCellText>
                </StyledHeaderCellBoldWrapper>
                {props.tooltipText ? (
                    <PlainTooltip
                        placement={"right"}
                        tooltipContent={<I18n translatable={{ key: props.tooltipText }} />}
                    >
                        <StyledIconInfoWrapper>
                            <SWReactIcons
                                iconName="info"
                                size="xs"
                            />
                        </StyledIconInfoWrapper>
                    </PlainTooltip>
                ) : null}
            </>
        </HeaderCellBoldWithInfoWrapper>
    );
};

export default HeaderCellBoldWithInfoIcon;
